var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgClose(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "vuesax/outline/close-circle"
  }, /*#__PURE__*/React.createElement("g", {
    id: "close-circle"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M9.99935 18.9583C5.05768 18.9583 1.04102 14.9416 1.04102 9.99996C1.04102 5.05829 5.05768 1.04163 9.99935 1.04163C14.941 1.04163 18.9577 5.05829 18.9577 9.99996C18.9577 14.9416 14.941 18.9583 9.99935 18.9583ZM9.99935 2.29163C5.74935 2.29163 2.29102 5.74996 2.29102 9.99996C2.29102 14.25 5.74935 17.7083 9.99935 17.7083C14.2493 17.7083 17.7077 14.25 17.7077 9.99996C17.7077 5.74996 14.2493 2.29163 9.99935 2.29163Z",
    fill: "#F04438"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M7.64245 12.9834C7.48411 12.9834 7.32578 12.925 7.20078 12.8C6.95911 12.5584 6.95911 12.1584 7.20078 11.9167L11.9174 7.20005C12.1591 6.95838 12.5591 6.95838 12.8008 7.20005C13.0424 7.44172 13.0424 7.84172 12.8008 8.08338L8.08411 12.8C7.96745 12.925 7.80078 12.9834 7.64245 12.9834Z",
    fill: "#F04438"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M12.3591 12.9834C12.2008 12.9834 12.0424 12.925 11.9174 12.8L7.20078 8.08338C6.95911 7.84172 6.95911 7.44172 7.20078 7.20005C7.44245 6.95838 7.84245 6.95838 8.08411 7.20005L12.8008 11.9167C13.0424 12.1584 13.0424 12.5584 12.8008 12.8C12.6758 12.925 12.5174 12.9834 12.3591 12.9834Z",
    fill: "#F04438"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClose);
export default __webpack_public_path__ + "static/media/close.f13bc4a9ff5a90110ea6e8121da527c3.svg";
export { ForwardRef as ReactComponent };